import { BonusByProductTableTranslations } from "./";

export const BONUS_BY_PRODUCT_TABLE_ES_MX: BonusByProductTableTranslations = {
	title: "Bonificación por producto",
	filename: "bonus_by_product",
	columns: {
		product: "Producto",
		productCategory: "Categoría del Producto",
		bonusCategory: "Categoría del Producto",
		value: "Bonificación recibida durante el período",
		bonusSpentFromOtherPeriod: "Bonificación recibida en otro período",
		receivedInPeriod: "Recibido en el evento",
		receivedInOtherPeriod: "Recibido en otros eventos",
		total: "Total de la categoría",
		noCategory: "Sin categoría",
	},
	exportToExcel: "Exportar a Excel",
};
